import {Breadcrumbs, CircularProgress, Grid, Typography} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import PageTitle from '../../../common/PageTitle';
import LinkNavegacao from '../../../common/Link';
import CardOption from '../../../common/CardOption';
import { WorkersIcon } from '../../../common/Icons';
import React, {useEffect, useState} from "react";
import {verifyUserAbilities} from "../../../config/functions";

function People() {
    const [abilities, setAbilities] = useState({});
    const [loading, setLoading] = useState(true);

    const permissoesNecessarias = [
        { rota: "pessoas", title: "Colaboradores", description: "Gerencie os colaboradores da sua empresa", url: "colaboradores" },
        { rota: "pessoas", title: "Usuários Administrativos", description: "Gerencie as pessoas que tem acesso à administração dos sistemas", url: "usuarios" },
    ];

    useEffect(() => {
        const carregarPermissoes = async () => {
            const resultados = {};

            for (const item of permissoesNecessarias) {
                resultados[item.rota] = await verifyUserAbilities({ rota: item.rota });
            }

            setAbilities(resultados);
            setLoading(false);
        };

        carregarPermissoes();
    }, []);

    if (loading) {
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ height: "100vh" }}>
                <CircularProgress />
            </Grid>
        );
    }

    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="stretch"
            spacing={3}
        >
            <Grid item xs={12}>
                <Breadcrumbs>
                    <LinkNavegacao to='/'><HomeIcon fontSize='small' /></LinkNavegacao>
                    <Typography variant='span'>Gerenciamento</Typography>
                    <Typography variant='span'>Pessoas</Typography>
                </Breadcrumbs>
                <PageTitle icon={<WorkersIcon fontSize='large' />} title='Pessoas' />
            </Grid>

            {permissoesNecessarias.map((item) => {
                const temPermissao = abilities[item.rota]?.data.success;
                return (
                    <Grid
                        key={item.rota}
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={4}
                        xl={3}
                        sx={{
                            opacity: temPermissao ? 1 : 0.5,
                            pointerEvents: temPermissao ? 'auto' : 'none',
                        }}
                    >
                        <CardOption
                            title={item.title}
                            description={item.description}
                            url={item.url}
                            hasPermisson={temPermissao}
                            sx={{
                                backgroundColor: temPermissao ? 'transparent' : 'gray',
                                color: temPermissao ? 'black' : 'gray',
                            }}
                        />
                    </Grid>
                );
            })}
        </Grid>
    );
}

export default People;